(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["influencer-videos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('influencer-videos')) {
  customElements.define(
    'influencer-videos',
    class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.influencer-videos__viewport');
        this.cards = Array.from(this.querySelectorAll('.influencer-videos__card'));
        this.dots = Array.from(this.querySelectorAll('.influencer-videos__dot'));
        this.prevButton = this.querySelector('.influencer-videos__arrow--prev');
        this.nextButton = this.querySelector('.influencer-videos__arrow--next');

        if (!this.viewport || this.cards.length === 0) return;

        this.handleScroll = this.handleScroll.bind(this);
        this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.scrollToIndex(index));
        });

        if (this.prevButton) {
          this.prevButton.addEventListener('click', () => this.scrollToIndex(this.activeIndex() - 1));
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('click', () => this.scrollToIndex(this.activeIndex() + 1));
        }

        this.querySelectorAll('.influencer-videos__sound').forEach((button) => {
          button.addEventListener('click', () => this.toggleSound(button));
        });

        this.update();
      }

      disconnectedCallback() {
        if (this.viewport) {
          this.viewport.removeEventListener('scroll', this.handleScroll);
        }
      }

      activeIndex() {
        const center = this.viewport.scrollLeft + this.viewport.clientWidth / 2;
        let best = 0;
        let bestDistance = Infinity;

        this.cards.forEach((card, index) => {
          const cardCenter = card.offsetLeft + card.clientWidth / 2;
          const distance = Math.abs(cardCenter - center);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = index;
          }
        });

        return best;
      }

      scrollToIndex(index) {
        const clamped = Math.max(0, Math.min(this.cards.length - 1, index));
        const card = this.cards[clamped];
        const left = card.offsetLeft - (this.viewport.clientWidth - card.clientWidth) / 2;
        this.viewport.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }

      handleScroll() {
        if (this.rafId) return;
        this.rafId = requestAnimationFrame(() => {
          this.rafId = null;
          this.update();
        });
      }

      update() {
        const index = this.activeIndex();
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));

        if (this.prevButton) {
          this.prevButton.disabled = this.viewport.scrollLeft <= 2;
        }

        if (this.nextButton) {
          this.nextButton.disabled =
            this.viewport.scrollLeft + this.viewport.clientWidth >= this.viewport.scrollWidth - 2;
        }
      }

      toggleSound(button) {
        const card = button.closest('.influencer-videos__card');
        if (!card) return;

        const video = card.querySelector('video');
        if (!video) return;

        if (video.muted) {
          this.querySelectorAll('video').forEach((other) => {
            other.muted = true;
          });
          this.querySelectorAll('.influencer-videos__sound').forEach((other) => {
            other.setAttribute('aria-pressed', 'false');
          });
          video.muted = false;
          if (typeof video.play === 'function') video.play();
          button.setAttribute('aria-pressed', 'true');
        } else {
          video.muted = true;
          button.setAttribute('aria-pressed', 'false');
        }
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();
})();
